<template>
  <v-layout row wrap px-2 py-1 v-if="comment.author.username===systemComment">
    <span class="system-comment">
      <v-icon class="pr-2">event</v-icon>{{comment.comment}}</span>
    <span class="system-comment">
      {{comment.commentDate | time}}
    </span>

    <v-layout pt-4 v-if="intervention.intervention.referee && intervention.intervention.consented">
      <span class="system-comment">
        <v-icon class="pr-2">check_box</v-icon>{{$t('intervention_consent')}}</span>
    </v-layout>
  </v-layout>
  <v-layout row wrap pa-2 v-else>
    <v-flex xs12 class="prevent-overflow" :class="commentClass">{{comment.comment}}
    </v-flex>
    <v-flex xs6>{{comment.interventionCommentAuthorName}}</v-flex>
    <v-flex xs6 text-xs-right>{{comment.commentDate | time}}</v-flex>
  </v-layout>

</template>

<script>
  import { mapState } from 'vuex'
  import DateFormat from '../../../mixins/DateFormat'

  export default {
    name: 'intervention-comment',
    props: ['comment', 'intervention'],
    mixins: [DateFormat],
    data () {
      return {
        systemComment: 'SYSTEM'
      }
    },
    computed: {
      ...mapState({
        username: state => state.profile.username
      }),
      commentClass () {
        return this.username.toUpperCase() === this.comment.author.username.toUpperCase() ? 'comment-main' : 'comment-secondary'
      }
    }
  }
</script>

<style scoped>
  .system-comment {
    text-align: center;
    width: 100%;
  }

  .comment-main {
    position: relative;
    border-radius: .4em;
    margin-bottom: .3em;
    margin-top: 1em;
    padding: 1em;
    margin-left: 10px;
  }

  .comment-main:after {
    content: '';
    position: absolute;
    border-style: solid;
    border-width: 15px 15px 0px 0;
    display: block;
    width: 0;
    z-index: 1;
    margin-top: -15px;
    left: -10px;
    top: 100%;
  }

  .comment-secondary {
    position: relative;
    border-radius: .4em;
    margin-bottom: .3em;
    margin-top: 1em;
    margin-right: 10px;
    padding: 1em;
  }

  .comment-secondary:after {
    content: '';
    position: absolute;
    border-style: solid;
    border-width: 15px 0 0 15px;
    display: block;
    width: 0;
    z-index: 1;
    margin-top: -15px;
    right: -10px;
    top: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/intervention/studentProfileIntervention/InterventionComment.vue